export enum UserRoles {
  Admin = 'admin',
  SuperAdmin = 'superAdmin',
}
